"use strict";

const DragDropPort = {
  add: function () {
    document.addEventListener("dragstart", (e) => {
      const draggable = e.target.closest(".drag-drop--draggable");
      if (draggable) {
        const height = draggable.getBoundingClientRect().height;
        document.documentElement.style.setProperty(
          "--drag-item-height",
          `${height}px`,
        );
      }
    });

    document.addEventListener("dragend", (e) => {
      if (e.target.closest(".drag-drop--draggable")) {
        document.documentElement.style.removeProperty("--drag-item-height");
      }
    });
  },
};

module.exports = DragDropPort;
